export default __webpack_public_path__ + "static/media/icon-prop-delete.ad48f65d.svg";